import {
    VictoryAxis,
} from "victory";


class CustomVictoryAxis extends VictoryAxis {
    fixLabelOverlap(gridAndTicks, props) {
        let result = super.fixLabelOverlap(gridAndTicks, props);
        return result;

        // let filteredResultKey = {};
        // let filteredResult = [];
        //
        // for (let i = 0; i < result.length; i++) {
        //     const date = result[i].props.children[2].props.text;
        //     if (!filteredResultKey[date]) {
        //         if (i > 0) {
        //             const prevObj = result[i - 1];
        //             if (prevObj.props.children[2].props.text !== date) {
        //                 filteredResultKey[date] = result[i];
        //                 filteredResult.push(result[i]);
        //             }
        //         } else {
        //             filteredResultKey[date] = result[i];
        //             filteredResult.push(result[i]);
        //         }
        //     }
        // }
        //
        // return filteredResult;
    }
}

export { CustomVictoryAxis as VictoryAxis }


// WEBPACK FOOTER //
// ./app/components/charts/victory/cost/VictoryAxis.js